export enum EventoEstadoPago {
  APROBADO = 'purchase',
  PENDIENTE = 'pago-pendiente',
  RECHAZADO = 'pago-rechazado',
  EXPIRADO = 'pago-expirado',
}
